  const delay = 45000;
  const banner = '.modal';
  const active = 'modal--active';
  const close = '.modal__button';
  // show banner on load
  document.addEventListener('DOMContentLoaded', () => {
    if(!localStorage['banner']) {
      document.querySelector(banner) && setTimeout(() => {
        document.querySelector(banner).classList.add(active);
      }, delay);  // close banner on button click
    }

    document.addEventListener('click', e => e.target.matches(close) && !(localStorage['banner'] = false) && e.target.closest(banner).classList.remove(active));
    $(document).on('gform_confirmation_loaded', e => !(localStorage['banner'] = false) && document.querySelector('.modal--active').classList.remove('modal--active'));
  });
 
 document.addEventListener('click', ({target}) => target.matches('.modal') && document.querySelector('.modal').classList.remove('modal--active'));
